@if (canShowAddressDropdown) {
  <ng-select
    [attr.id]="'ship-to-address-select-' + (delivery?.id ?? 'standalone')"
    #select
    [ngClass]="dropDownClasses"
    [items]="computedAddressList"
    bindValue="id"
    placeholder="Ship-to address"
    [searchable]="true"
    [loading]="addressesLoading"
    [typeahead]="addressesSubject"
    (change)="onSelect($event)"
    [clearable]="false"
    (close)="onCloseDropdown()"
    [disabled]="disabled"
    dropdownPosition="bottom"
    [(ngModel)]="addr_id"
  >
    <ng-template ng-label-tmp let-item="item">
      @if (delivery.addressDefined) {
        <span class="d-block fw-bold font-5">{{ addressLabel }}</span>
        <span>{{ delivery.street_1 }}, {{ delivery.getCSZ() }}</span>
      }
    </ng-template>
    <ng-template ng-header-tmp>
      <span class="font-6">{{ itemsTemplateHeader }}:</span>
    </ng-template>
    <ng-template ng-option-tmp let-item="item">
      <span class="fw-bold font-6">
        @if (item.is_default) {
          <i class="fas fa-star color-gold"></i>&nbsp;
        }
        {{ item.label }}</span
      ><br />
      <span class="font-6">{{ item.longAddress }}</span>
    </ng-template>
    <ng-template ng-footer-tmp>
      @if (canAddAddresses) {
        <a
          [attr.id]="'btn-add-new-address-' + (delivery?.id ?? 'standalone')"
          href="#"
          class="d-block text-align-center my-2 link font-5 link-underline"
          (click)="addAddress()"
          >Add New Address&nbsp;<i class="fas fa-plus"></i
        ></a>
      }
    </ng-template>
  </ng-select>
} @else {
  <app-shipping-label
    [delivery]="delivery"
    [isDecisionPoint]="isDecisionPoint"
    [wslrEntity]="wslrEntity"
    [attention]="attention"
  ></app-shipping-label>
}
